<template lang="html">
	<div
	id="about"
	data-sal="slide-up"
	data-sal-duration="2000"
	data-sal-easing="ease-out-back"
	class="section1-container">
		<h1>About the Project</h1>
		<p class="about-copy">72% of people worldwide are concerned that climate change will harm them personally at some point in their lifetime. And 80% of people are willing to change how they live and work to reduce the threat.</p>
		<p class="about-copy">We went looking for a simple way to make a difference. And found it right in front of our faces: A Purdue University study found that going camera-off reduces the environmental impact of video calls by 96%. And with 49% of remote workers reporting high levels of Zoom fatigue, who doesn't want an excuse to turn off their video?</p>
		<p class="about-copy">Just download one of the graphics available on CameraOffsetProject.com and set it as your profile picture in your video call platform of choice. You're reducing your environmental impact AND reducing the amount of time you spend looking at your own face in boring work calls. Win-win!</p>
		<div class="thumbnail-container">
			<img class="thumbnail" src="@/assets/img/thumbnails/BecauseICare.png">
			<img class="thumbnail" src="@/assets/img/thumbnails/CameraOffset.png">
			<img class="thumbnail" src="@/assets/img/thumbnails/CantMoveToSpace.png">
			<img class="thumbnail" src="@/assets/img/thumbnails/DontLookAtMe.png">
			<img class="thumbnail" src="@/assets/img/thumbnails/BecauseICare.png">
			<img class="thumbnail" src="@/assets/img/thumbnails/HideYourFace.png">
		</div>
	</div>
</template>

<script>
import sal from "sal.js"; // No need to use in main.js file

export default {
    mounted() {
        sal();
    },
}
</script>

<style scoped lang="scss">
.section1-container {
	width: 80%;
	max-width: 800px;
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	h1 {
		padding-top:50px;
		font-size:40px;
		color: black;
		font-weight: 800;
    font-size: 3rem;
    font-family: ITCSouvenirBold;
    z-index: 1000;
		text-decoration: underline;
		text-decoration-color: $main-2;
	}
	.thumbnail-container {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-flow: wrap;
		padding-top: 25px;
		.thumbnail{
			padding:10px;
			width: 200px;
			height: 200px;
		}
	}
}
    
.about-copy {
	font-size: 20px;
	padding: 15px;
}
</style>